var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V13",
    stroke: "#F7C23A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16,
    r: 0.5,
    fill: "#F7C23A",
    stroke: "#F7C23A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6873 20H5.31273C3.80771 20 2.84193 18.4003 3.54289 17.0685L10.2302 4.36269C10.98 2.93801 13.02 2.93802 13.7698 4.36269L20.4571 17.0685C21.1581 18.4003 20.1923 20 18.6873 20Z",
    stroke: "#F7C23A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.7e39f9291a4456bada5b983bfeda9218.svg";
export { ForwardRef as ReactComponent };